import enviro from 'enviro';
import { createTracker } from 'usage-tracker';
import events from './events.yaml';
const tracker = createTracker({
  trackerName: 'commerce-subscriptions-tracker',
  events,
  properties: {
    namespace: 'commerce-subscription'
  },
  lastKnownEventProperties: ['app', 'paymentType'],
  debug: () => enviro.debug('commerce-subscription-lib'),
  preserveTrackerEvents: true,
  bypassPool: true
});
function track(app, eventName, values) {
  if (values instanceof Array) {
    values.forEach(value => {
      tracker.track(eventName, Object.assign({}, value, {
        app
      }));
    });
  } else {
    tracker.track(eventName, Object.assign({}, values, {
      app
    }));
  }
}
function debug(app, eventName, values) {
  console.group('SubscriptionTracker');
  console.log(`debug: '[Commerce Subscription] ${app} - ${eventName}'`);
  console.table(values);
  console.groupEnd();
}
export function getTracker(app,
// typescript trick to allow autocomplete of known strings
shouldDebug) {
  return (eventName, values) => shouldDebug ? debug(app, eventName, values) : track(app, eventName, values);
}